import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
const SchemaBuilderContext = createContext({});
export const useSchemaBuilderContext = () => useContext(SchemaBuilderContext);
export function SchemaBuilderContextProvider({ variablesSchema, referenceCollections, referenceSchemas, readOnly, isObject, children, }) {
    const value = useMemo(() => ({
        variablesSchema,
        referenceCollections,
        referenceSchemas,
        readOnly,
        isObject,
    }), [
        variablesSchema,
        JSON.stringify(referenceCollections),
        JSON.stringify(referenceSchemas),
        isObject,
        readOnly,
    ]);
    return (_jsx(SchemaBuilderContext.Provider, { value: value, children: children }));
}
//# sourceMappingURL=SchemaContext.js.map